<ng-container *ngIf="activeCompany$ | async as activeCompany">
    <h2>{{ activeCompany?.name | strictTitleCase }}</h2>
    <div class="d-inline-flex">
        <a
            [routerLink]="['/sb-grid/private-equity-transaction-form']"
            [queryParams]="{ instrumentId: activeCompany?.instrumentId }"
            class="btn btn-sm secondary"
        >
            Add Investment
        </a>
        <a
            [routerLink]="[
                '/sb-grid/private-equity-company-form',
                activeCompany?.instrumentId
            ]"
            class="btn btn-sm secondary"
        >
            Edit Company
        </a>
    </div>
    <app-company-valuation></app-company-valuation>
    <sb-pills [pills]="routes"></sb-pills>
    <router-outlet></router-outlet>
</ng-container>
